export default function isMobileMediaQuery(theme: Record<string, any>): boolean {
  return (typeof ((theme as {mobile: {mediaQuery: string}})?.mobile?.mediaQuery) === 'string');
}
